// extracted by mini-css-extract-plugin
export default {"dialog":"dialog__Rpq0W","btn-close":"btn-close__a8GRN","content":"content__uBiHw","grid":"grid__v9P4k","grid-item":"grid-item__SyJOo","loader":"loader__p0B5b","image":"image__2A3eo"};